/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["h2[_ngcontent-%COMP%]{margin:0;color:var(--main-color)}  .actions *{float:right}"];
export { styles as styles };

